export default __webpack_public_path__ + "a849275fff92e9379b513d05b8a55d9b.png";